// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__mg+GY","closeContainer":"PageHeader_closeContainer__x9Jju","text":"PageHeader_text__atk8Q"};